import { motion } from "framer-motion";
import aboutImg from "../assets/about-meeting.png";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#FAFAFA] py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-120px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-6 relative"
          >
            <div className="relative overflow-hidden">
              <img
                src={aboutImg}
                alt="Salle de réunion du cabinet LJMG"
                className="w-full h-[420px] md:h-[560px] object-cover"
                data-testid="about-image"
              />
              {/* Red accent corner */}
              <span
                className="absolute -bottom-4 -right-4 w-24 h-24 border-r-2 border-b-2 border-[#E10600] hidden md:block"
                aria-hidden="true"
              />
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-120px" }}
            transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-6 lg:pl-4"
          >
            <div className="flex items-center gap-4 mb-8">
              <span className="accent-bar-sm" aria-hidden="true" />
              <span className="text-xs tracking-[0.25em] uppercase text-[#6B7280] font-medium">
                À propos
              </span>
            </div>

            <h2
              data-testid="about-title"
              className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#0A0A0A]"
            >
              Une expertise<br />
              au service des<br />
              <span className="italic font-normal">agences immobilières.</span>
            </h2>

            <div className="mt-10 space-y-6 text-[#374151] font-light leading-relaxed text-base md:text-lg max-w-xl">
              <p data-testid="about-paragraph-1">
                Fondée par Jacques Langelle, LJMG est une structure indépendante
                dédiée à l'accompagnement des agences immobilières. Nous mettons
                notre connaissance du marché et notre réseau au service du
                développement commercial des agences.
              </p>
              <p data-testid="about-paragraph-2">
                En facilitant la mise en relation avec des clients qualifiés et
                en proposant des prestations connexes adaptées à chaque
                structure, nous portons un engagement clair&nbsp;: discrétion,
                rigueur et résultats concrets.
              </p>
            </div>

            {/* Signature */}
            <div className="mt-12 flex items-center gap-5" data-testid="about-signature">
              <span className="block w-10 h-[2px] bg-[#E10600]" aria-hidden="true" />
              <div className="flex flex-col">
                <span className="font-serif text-lg text-[#0A0A0A]">
                  Jacques Langelle
                </span>
                <span className="text-xs tracking-[0.15em] uppercase text-[#6B7280] mt-1">
                  Gérant fondateur
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
